// Module
var code = "<div class=horizontal-stacked-bar-chart> <h3 class=chart-title></h3> <div class=chart-icon ng-if=chartIcon> <img ng-src={{chartIcon}} alt=chart-icon> </div> <div class=horizontal-stacked-bar-chart-content></div> </div> ";
// Exports
module.exports = code;